var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_html.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_html.js
// module chunks = 0